<template>
  <div class="suggest-wrapper">
    <div class="search-form">
      <input type="text" class="input" id="fullAddress" @input="component.search" v-model="component.field.word"
        autocomplete="off" placeholder="Enter your address to check available"
        v-on:keyup.enter="component.selectAddress(undefined)">
      <button type="button" @click="component.selectAddress(undefined)">
        <SearchIcon height="20px" width="20px" viewBox="0 0 120 150"></SearchIcon>
        <span> Check Address</span>
      </button>
    </div>
    <ul id="suggest-list" :class="{ 'hidden': component.isHidden.value }">
      <li v-for="( suggest, index ) in  component.suggestions " :key="index" @click="component.selectAddress(suggest)"
        @touchend="component.selectAddress(suggest)" @tap="component.selectAddress(suggest)">
        {{ suggest.formattedAddress }}
      </li>
    </ul>
  </div>
  <Modal v-model:visible="isVisible" title="Contact Form"
    :okButton="{ text: 'send', onclick: component.send.bind(component), loading: true }">
    <div class="modal-body">
      <Contact />
    </div>

    <div :class="{ 'hidden': store.$state.valid }">
      Please fill out the form.
    </div>
  </Modal>
</template>

<script setup lang="ts">
import SearchIcon from '../icons/search-icon.vue'
import component from './search.component'
import { Modal } from 'usemodal-vue3';
// import MdInput from "vue-material/MdInput"
import Contact from './../contact/contact.component.vue'
import useMainStore from './../stores/main.store';
let isVisible = component.isModalVisible;
const store = useMainStore();
// console.log(store.$state.valid);
// let isSent = store.$state.valid;
</script>
